const FALLBACK_PUBLIC_API_URL = 'https://mandira.mauracher.cc/api';

export function getPublicApiBaseUrl(): string {
  const configuredBaseUrl = import.meta.env.VITE_APP_PUBLIC_API?.trim();

  if (!configuredBaseUrl) {
    return FALLBACK_PUBLIC_API_URL;
  }

  return configuredBaseUrl.replace(/\/+$/, '');
}

export function getPublicApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${getPublicApiBaseUrl()}${normalizedPath}`;
}
